const partsData = [
  {
    name: "AMF REECE Atlas Mark IV",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/AtlasMarkIVParts.pdf",
  },
  {
    name: "AMF REECE AutoJig 84-55 Parts List",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/AMF-REECE-AutoJig-84-55-Parts-List-5131.zip",
  },
  {
    name: "AMF REECE AutoJig 84-71 MJ Parts List",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/AJ8472MJParts.pdf",
  },
  {
    name: "AMF REECE AutoJig 84-72 MC Parts List",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/AJ8472MCParts.pdf",
  },
  {
    name: "AMF REECE AutoJig 84-72 MS Parts List",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/AJ8472MSParts.pdf",
  },
  {
    name: "AMF REECE AutoTrak 84-78 Parts List",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/Autotrak8478Parts.pdf",
  },
  {
    name: "AMF REECE AutoTrak CNC Parts List",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/AutotrackCNCParts.pdf",
  },
  {
    name: "AMF REECE BL-3100 Parts List",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/BL3100Parts.pdf",
  },
  {
    name: "AMF REECE BSW - MARK III",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/MSWMarkIIIParts.pdf",
  },
  {
    name: "AMF REECE BT-2700 BT-3200 Parts List",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/BT2700parts.pdf",
  },
  {
    name: "AMF REECE CBS 13 Parts List",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/CBS13Parts.pdf",
  },
  {
    name: "AMF REECE DECO 2000 Parts List",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/Deco2000Parts.pdf",
  },
  {
    name: "AMF REECE EBS - MARK II Parts List",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/EBSMarkIIparts.pdf",
  },
  {
    name: "AMF REECE ES-505",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/AMFRES505Parts.pdf",
  },
  {
    name: "AMF REECE ES-505 INDEXER",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/ES505Indexer.pdf",
  },
  {
    name: "AMF Reece ES-505 Parts List",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/ES505Parts.pdf",
  },
  {
    name: "AMF REECE LW 7001",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/LW7001pockweltparts.pdf",
  },
  {
    name: "AMF REECE PF2200 Automatic Short Seamer Parts List",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/PF2200Parts.pdf",
  },
  {
    name: "AMF REECE PS250 Parts List",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/PS250Parts.pdf",
  },
  {
    name: "AMF REECE S-100 Parts List",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/S100.pdf",
  },
  {
    name: "AMF REECE S-101 Parts List",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/S101.pdf",
  },
  {
    name: "AMF REECE S-104 Parts List",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/S104.pdf",
  },
  {
    name: "AMF REECE S-105 Parts List",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/S105.pdf",
  },
  {
    name: "AMF REECE S-311 Parts List",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/S311.pdf",
  },
  {
    name: "AMF REECE S-311 Parts List (1)",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/AMFRS311Parts.pdf",
  },
  {
    name: "AMF REECE S-311 Parts List (2)",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/AMFRS311Parts_2.pdf",
  },
  {
    name: "AMF REECE S-311+I Parts List (Indexer)",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/S311Indexer.pdf",
  },
  {
    name: "AMF REECE S-4000 BH Omron Parts List",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/s4000bhparts.pdf",
  },
  {
    name: "AMF REECE S-4000 CAED Omron Parts List",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/S4000caedparts.pdf",
  },
  {
    name: "AMF REECE S-4000 ISBH+I SM Parts List",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/S4001isbhindexersmparts.pdf",
  },
  {
    name: "AMF REECE S-4000 LS TKF Omron Parts List",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/S4000LS.pdf",
  },
  {
    name: "AMF REECE S-4000 LT Omron Parts List",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/S4000LT.pdf",
  },
  {
    name: "AMF REECE S-4000 TKF Parts List",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/S4000TKFParts.pdf",
  },
  {
    name: "AMF REECE S-4000 TKF, Lab Feed, LS Omron Parts List",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/S4000TKFLabFeedParts.pdf",
  },
  {
    name: "AMF REECE S-4001 ISBH+I SM Parts List",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/S4001isbhindexersmparts.pdf",
  },
  {
    name: "AMF REECE S-4002 Parts List",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/S4002.pdf",
  },
  {
    name: "AMF REECE TH-5500 Parts List",
    brand: "AMF Reece",
    link: "https://media.dsinternational.com/parts/AMF%20REECE/TH5500Parts.pdf",
  },
  {
    name: "BF EX3200, EX5200 Series",
    brand: "BF",
    link: "https://media.dsinternational.com/parts/BF/BFEX3200EX5200Parts.pdf",
  },
  {
    name: "BROTHER BAS-102V PARTS LIST",
    brand: "Brother",
    link: "https://media.dsinternational.com/parts/Brother/102VEng.pdf",
  },
  {
    name: "BROTHER KE-436C PARTS LIST",
    brand: "Brother",
    link: "https://media.dsinternational.com/parts/Brother/KE436Ceng.pdf",
  },
  {
    name: "BROTHER KM-4300 PARTS LIST",
    brand: "Brother",
    link: "https://media.dsinternational.com/parts/Brother/km4300.pdf",
  },
  {
    name: "CONSEW Model 241-1K Parts List",
    brand: "Consew",
    link: "https://media.dsinternational.com/parts/Consew/241-1K.pdf",
  },
  {
    name: "CONSEW Model 697CVF Parts List",
    brand: "Consew",
    link: "https://media.dsinternational.com/parts/Consew/697CVF.pdf",
  },
  {
    name: "CONSEW Model 733R-5 & 733R-6 Instruction Manual & Parts Lists",
    brand: "Consew",
    link: "https://media.dsinternational.com/parts/Consew/733R-5%20733R-6.pdf",
  },
  {
    name: "CONSEW Model 75T Instruction & Parts Manual",
    brand: "Consew",
    link: "https://media.dsinternational.com/parts/Consew/75TManualPgOrder.pdf",
  },
  {
    name: "CONSEW CM793/CM794/CM795 Instruction Manual & Parts Lists",
    brand: "Consew",
    link: "https://media.dsinternational.com/parts/Consew/CM793.pdf",
  },
  {
    name: "CONSEW CN-27A Parts List",
    brand: "Consew",
    link: "https://media.dsinternational.com/parts/Consew/CN-27A.pdf",
  },
  {
    name: "CONSEW CN-2033R/CN-2043R/CN-2053R Parts Lists",
    brand: "Consew",
    link: "https://media.dsinternational.com/parts/Consew/CN7A.pdf",
  },
  {
    name: "C/SRE AP-142E Espandable Spreader Parts Book",
    brand: "CSRE",
    link: "https://media.dsinternational.com/parts/CSRE/AP142EPARTS.pdf",
  },
  {
    name: "Horray 52L Parts List",
    brand: "Horray",
    link: "https://media.dsinternational.com/parts/Horray/Horray52LParts.pdf",
  },
  {
    name: "Accessories Catalogue",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/Accessories%20List%20MO.pdf",
  },
  {
    name: "Dx-15000 QVP Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/DX-15000QVP%20Parts%20List.pdf",
  },
  {
    name: "Dx-3000 QVP Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/DX-3000QVP%20Parts%20List.pdf",
  },
  {
    name: "Dx-4000 QVP Parts List 2",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/DX-4000QVP%20Parts%20List%202.pdf",
  },
  {
name: "Dx-4000 QVP Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/DX-4000QVP%20Parts%20List.pdf",
  },
  {
    name: "HZL-27z Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/HZL-27z%20Parts%20List%28%20%29.pdf",
  },
  {
    name: "HZL-35z Parts list(final)",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/HZL-35z%20Partslist%28final%29.pdf",
  },
  {
    name: "HZL-70hw Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/HZL-70HW%20Parts%20List.pdf",
  },
  {
    name: "HZL-80hp Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/HZL-80HP%20Parts%20List.pdf",
  },
  {
    name: "HZL-F Series Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/HZL-F%20Series%20Parts%20List%20%28%29.pdf",
  },
  {
    name: "HZL-G Parts Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/HZL-G%20Parts%20Manual.pdf",
  },
  {
    name: "HZL-Ht710 Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/HZL-Ht710%20Parts%20List.pdf",
  },
  {
    name: "HZL-Ht740 Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/HZL-Ht740%20Parts%20List.pdf",
  },
  {
    name: "HZL-K65 Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/HZL-K65%20Parts%20List.pdf",
  },
  {
    name: "HZL-K85 Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/HZL-K85%20Parts%20List.pdf",
  },
  {
    name: "HZL-Nx7 Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/HZL-NX7%20Parts%20List.pdf",
  },
  {
    name: "Hzl25z Parts list",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/Hzl25z%20Partslist.pdf",
  },
  {
    name: "Hzle61 Parts list",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/Hzle61%20Partslist.pdf",
  },
  {
    name: "Hzle70 Parts list",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/Hzle70%20Partslist.pdf",
  },
  {
    name: "Hzle71 Parts list",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/Hzle71%20Partslist.pdf",
  },
  {
    name: "Hzle80 Parts list",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/Hzle80%20Partslist.pdf",
  },
  {
    name: "Hzlt100 Parts list",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/Hzlt100%20Partslist.pdf",
  },
  {
    name: "J-150qvp Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/J-150QVP%20PARTS%20LIST.pdf",
  },
  {
    name: "J-350qvp Service And Parts Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/J-350QVP%20Service%20and%20Parts%20Manual.pdf",
  },
  {
    name: "Juki Acf-161-981 Button Attaching Indexer",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/Juki%20ACF-161-981%20Button%20Attaching%20Indexer.pdf",
  },
  {
    name: "Juki Dx Parts",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/JUKI%20DX%20Parts.pdf",
  },
  {
    name: "Juki Tajima Sai Parts List Cap Frame Pocket Frame",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/JUKI%20Tajima%20Sai%20Parts%20List%20CAP%20FRAME%20POCKET%20FRAME.pdf",
  },
  {
    name: "Juki Tajima Sai Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/JUKI%20Tajima%20Sai%20Parts%20List.pdf",
  },
  {
    name: "Juki AK-138 Autolifter",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/JukiAK138Autolifter.pdf",
  },
  {
    name: "Mcs-1500 Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/MCS-1500%20Parts%20List.pdf",
  },
  {
    name: "MO-1000 Parts Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/MO-1000%20Parts%20Manual.pdf",
  },
  {
    name: "MO-102 Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/MO-102%20Parts%20List.pdf",
  },
  {
    name: "MO-103 Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/MO-103%20Parts%20List.pdf",
  },
  {
    name: "MO-104 Parts List Jpn",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/MO-104%20Parts%20List%20JPN.pdf",
  },
  {
    name: "MO-104 Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/MO-104%20Parts%20List.pdf",
  },
  {
    name: "MO-114d Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/MO-114D%20Parts%20List.pdf",
  },
  {
    name: "MO-134 Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/MO-134%20Parts%20List.pdf",
  },
  {
    name: "MO-613v Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/MO-613V%20Parts%20List.pdf",
  },
  {
    name: "MO-623 Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/MO-623%20Parts%20List.pdf",
  },
  {
    name: "MO-623partslist",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/MO-623PartsList.pdf",
  },
  {
    name: "MO-644 Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/MO-644%20Parts%20List.pdf",
  },
  {
    name: "MO-644partslist",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/MO-644PartsList.pdf",
  },
  {
    name: "MO-654de Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/MO-654DE%20Parts%20List.pdf",
  },
  {
    name: "MO-654DE Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/MO-654DEPartsList.pdf",
  },
  {
    name: "MO-655 Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/MO-655%20Parts%20List.pdf",
  },
  {
    name: "MO-655 Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/MO-655PartsList.pdf",
  },
  {
    name: "MO-700 Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/MO-700%20Parts%20List.pdf",
  },
  {
    name: "MO-80CB Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/MO-80CB%20Parts%20List.pdf",
  },
  {
    name: "MO-80cb Recommendable Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/MO-80CB%20Recommendable%20Parts%20List.pdf",
  },
  {
    name: "MO-80CB Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/MO-80CBPartsList.pdf",
  },
  {
    name: "MO-2800 Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/MO2800%20Parts%20List.pdf",
  },
  {
    name: "MO-634D Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/Mo634dparts%20List.pdf",
  },
  {
    name: "MO-700 Parts list",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/Mo700%20Partslist.pdf",
  },
  {
    name: "Tl-18qvp Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/TL-18QVP%20Parts%20List.PDF",
  },
  {
    name: "Tl-2010Q 2000QI Parts list",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/TL-2010Q_2000Qi_PartsList.pdf",
  },
  {
    name: "Tl-2200QVP Mini Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/TL-2200QVP%20Mini%20parts%20list.pdf",
  },
  {
    name: "Tl-2200QVP Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/TL-2200QVP%20Parts%20List.pdf",
  },
  {
    name: "Tl-2200QVP-S Service And Parts Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/TL-2200QVP-S%20Service%20and%20Parts%20Manual.pdf",
  },
  {
    name: "Tl-2200qvp-S Table Parts",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/TL-2200QVP-S%20Table%20Parts.pdf",
  },
  {
    name: "Tl98e Parts list",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/Tl98e%20Partslist.pdf",
  },
  {
    name: "Tl-98Q 98P Parts list",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/Tl98q%2098p%20Partslist.pdf",
  },
  {
    name: "Tl-98QE Parts list",
    brand: "Juki",
    link: "https://media.dsinternational.com/parts/Juki/Tl98qe%20Partslist.pdf",
  },
  {
    name: "Kansai Special BX Series Parts List",
    brand: "Kansai",
    link: "https://media.dsinternational.com/parts/Kansai/KansaiBXParts.pdf",
  },
  {
    name: "Kansai Special DVK Series Parts List",
    brand: "Kansai",
    link: "https://media.dsinternational.com/parts/Kansai/KansaiDVKParts.prd_.pdf",
  },
  {
    name: "Kansai Special DX Series Parts Lists",
    brand: "Kansai",
    link: "https://media.dsinternational.com/parts/Kansai/Kansaidxparts.pdf",
  },
  {
    name: "Label Data parts English",
    brand: "Label Data",
    link: "https://media.dsinternational.com/parts/Label%20Data/LabelDataPartsEN.pdf",
  },
  {
    name: "Label Data parts Spanish",
    brand: "Label Data",
    link: "https://media.dsinternational.com/parts/Label%20Data/LabelDataPartsSP.pdf",
  },
  {
    name: "MITSUBISHI CU 865 PARTS LIST",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/CU-865.pdf",
  },
  {
    name: "MITSUBISHI DB 189 PARTS LIST",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/DB-189-PARTS-BOOK.pdf",
  },
  {
    name: "MITSUBISHI DY 253 PARTS LIST",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/DY-253-PARTS-BOOK-1.pdf",
  },
  {
    name: "MITSUBISHI LG2 3370 PARTS LIST",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/LG2-3370-PARTS-BOOK.pdf",
  },
  {
    name: "MITSUBISHI LS2 1130 PARTS LIST",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/LS2-1130-PARTS-BOOK.pdf",
  },
  {
    name: "MITSUBISHI LS2 1180 PARTS LIST",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/LS2-1180-PARTS-BOOK.pdf",
  },
  {
    name: "MITSUBISHI LS2 1280 PARTS LIST",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/LS2-1280-PARTS-BOOK.pdf",
  },
  {
    name: "MITSUBISHI LS2 150 PARTS LIST",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/LS2-150-PARTS-BOOK-1.pdf",
  },
  {
    name: "MITSUBISHI LS2 180 PARTS LIST",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/LS2-180-PARTS-BOOK.pdf",
  },
  {
    name: "MITSUBISHI LS2 190 PARTS LIST",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/LS2-190-PARTS-BOOK.pdf",
  },
  {
    name: "MITSUBISHI LS2 210 PARTS LIST",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/LS2-210-PARTS-BOOK.pdf",
  },
  {
    name: "MITSUBISHI LS2 2210 PARTS LIST",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/LS2-2210-PARTS-BOOK.pdf",
  },
  {
    name: "MITSUBISHI LS5 5110 5120 PARTS LIST",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/LS5-5110-5120-PARTS-BOOK.pdf",
  },
  {
    name: "MITSUBISHI LT2 2230 PARTS LIST",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/LT2-2230-PARTS-BOOK.pdf",
  },
  {
    name: "MITSUBISHI LT2 2250 AUTO CHANGER PARTS LIST",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/LT2-2250-AUTO-CHANGER-PARTS-BOOK.pdf",
  },
  {
    name: "MITSUBISHI LT2 2250 PARTS LIST",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/LT2-2250-PARTS-BOOK.pdf",
  },
  {
    name: "MITSUBISHI LT2 230 PARTS LIST",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/LT2-230-PARTS-BOOK.pdf",
  },
  {
    name: "MITSUBISHI LT2 250 AUTO CHANGER PARTS LIST",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/LT2-250-AUTO-CHANGER-PARTS-BOOK.pdf",
  },
  {
    name: "MITSUBISHI LT2 250 PARTS LIST",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/LT2-250-PARTS-BOOK.pdf",
  },
  {
    name: "MITSUBISHI LU2 410-430 PARTS LIST",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/LU2-410-430-PARTS-BOOK.pdf",
  },
  {
    name: "MITSUBISHI LU2 4410-4430 PARTS LIST",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/LU2-4410-4430-PARTS-BOOK.pdf",
  },
  {
    name: "MITSUBISHI LU2 4710-4730 PARTS LIST",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/LU2-4710-4730-PARTS-BOOK.pdf",
  },
  {
    name: "MITSUBISHI LU3 6860 PARTS LIST",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/LU3-6860-PARTS-BOOK.pdf",
  },
  {
    name: "MITSUBISHI LY2 3300 PARTS LIST",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/LY2-3300-PARTS-BOOK.pdf",
  },
  {
    name: "MITSUBISHI LY2 3310 PARTS LIST",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/LY2-3310-PARTS-BOOK.pdf",
  },
  {
    name: "MITSUBISHI LY2 3750 PARTS LIST",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/MITSUBISHI-LY2-3750-PARTS-LIST-7864.zip",
  },
  {
    name: "MITSUBISHI LY3 6840 PARTS LIST",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/LY3-6840-PARTS-BOOK.pdf",
  },
  {
    name: "MITSUBISHI LIMIServo X Servo Motor Parts List",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/Mitsubishi%20Limiservo%20X%20Parts.pdf",
  },
  {
    name: "MITSUBISHI PLK-J10050R3 Parts List",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/PLK-J10050R3%20Parts%20Book.pdf",
  },
  {
    name: "MITSUBISHI PLK-J2516-YU Parts List",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/PLK-J2516-YU%20Parts%20Book.pdf",
  },
  {
    name: "MITSUBISHI PLK-J4040R Parts List",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/PLK-J4040R%20Parts%20Book.pdf",
  },
  {
    name: "MITSUBISHI PLK-J4040RH Parts List",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/PLK-J4040RH%20Parts%20Book.pdf",
  },
  {
    name: "MITSUBISHI PLK-J6040 Parts List",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/PLK-J6040%20Parts%20Book.pdf",
  },
  {
    name: "MITSUBISHI PLK-J6040R Parts List",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/parts/Mitsubishi/PLK-J6040R%20Parts%20Book.pdf",
  },
  {
    name: "PEGASUS AT/TK Tape Cutter Device Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/ATTKTAPECUTDEV.pdf",
  },
  {
    name: "PEGASUS BF - EX3200 / EX5200 Series Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/BFEX3200EX5200Parts.pdf",
  },
  {
    name: "PEGASUS BL500 Series / BL600 Series Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/BL500BL600PARTS.pdf",
  },
  {
    name: "PEGASUS BL900 Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/BL900.pdf",
  },
  {
    name: "PEGASUS BT180 Backlatcher (M752 Series) Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/BT180.pdf",
  },
  {
    name: "PEGASUS EH Device Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/EHEX5200EXT5200LX5200.pdf",
  },
  {
    name: "PEGASUS E-Series (Left Hand: E32L / E52L / E22L) Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/ESERIESE32LE52LE22L-1.pdf",
  },
  {
    name: "PEGASUS EX2200 Series Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/EX2200.pdf",
  },
  {
    name: "PEGASUS EX3200 Series / EX5200 Series Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/EX32005200.pdf",
  },
  {
    name: "PEGASUS EX3200N Series / EX5200N Series Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/EX3200NSerEX5200NSer.pdf",
  },
  {
    name: "PEGASUS EX5100 Series Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/EX5100.pdf",
  },
  {
    name: "PEGASUS EX5400 Series Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/EX5400Ser.pdf",
  },
  {
    name: "PEGASUS EXT3200 Series / EXT 5200 Series Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/EXT3200SerEXT5200Ser.pdf",
  },
  {
    name: "PEGASUS EX(T)5100 Series Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/EXT5100.pdf",
  },
  {
    name: "PEGASUS EX(T)5105 Series Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/EXT5105Series.pdf",
  },
  {
    name: "PEGASUS FS601 / FS613 Feed-Off-The-Arm Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/FS601FS613Parts.pdf",
  },
  {
    name: "PEGASUS FS700 Series",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/FS700Series.pdf",
  },
  {
    name: "PEGASUS KL Device (EXT3200/EXT5200 Series) Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/KLEXT3200EXT5200.pdf",
  },
  {
    name: "PEGASUS KS Device (EX5100/EXT5100 Series) Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/KSEX5100EXT5100.pdf",
  },
  {
    name: "PEGASUS KS/KH Chain Cutter Device (EX/EXT/LX Machine Series) Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/KSKHCHAINCUTTERDEV.pdf",
  },
  {
    name: "PEGASUS KS - KH M600 Series Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/KSKHM600.pdf",
  },
  {
    name: "PEGASUS KS/KH Chain Cutter Device (M700 Series) Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/KSKHM700.pdf",
  },
  {
    name: "PEGASUS M632 Series / M652 Series Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/M632Series.pdf",
  },
  {
    name: "PEGASUS M722 Series High Speed Double Chainstitch Machines Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/M722Series-1.pdf",
  },
  {
    name: "PEGASUS M732 Series / M752 Series Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/M732M752.pdf",
  },
  {
    name: "PEGASUS M832 Series / M852 Series Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/M832M852-1.pdf",
  },
  {
    name: "PEGASUS MC300 Feed Elastic Device Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/MC300.pdf",
  },
  {
    name: "PEGASUS MC400 Elastic Feeder (W/Tape Cutter/Inserter) Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/MC400.pdf",
  },
  {
    name: "PEGASUS PL021 M600 Series Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/PL021-1.pdf",
  },
  {
    name: "PEGASUS PL Device Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/plex32ex52ex54ext32.pdf",
  },
  {
    name: "PEGASUS S-Series (S32 / S52) Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/SSeriesS32S52-1.pdf",
  },
  {
    name: "PEGASUS TK Device M600 Series Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/TKM600.pdf",
  },
  {
    name: "PEGASUS TK Device M700 Series Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/TKM700.pdf",
  },
  {
    name: "PEGASUS TK Device MX Series / M800 Series Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/TKMXM800-1.pdf",
  },
  {
    name: "PEGASUS TM623 Multi-Needle Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/TM625MULTINEEDLE-1.pdf",
  },
  {
    name: "PEGASUS W700 Series (Short-bed Interlock Machine) Parts List",
    brand: "Pegasus",
    link: "https://media.dsinternational.com/parts/Pegasus/W700SERIESSHORTBED-1.pdf",
  },
  {
    name: "TEMPLEX Parts List",
    brand: "Templex",
    link: "https://media.dsinternational.com/parts/Templex/TEMPLEX.pdf",
  },
];
const manualsData = [
  {
    name: "BROTHER LT2-B841 Service Manual",
    brand: "Brother",
    link: "https://media.dsinternational.com/instruction/Brother/BrotherB842SERVICEMANUAL.pdf",
  },
  {
    name: "CONSEW 240/241/241-1K Service Manual",
    brand: "Consew",
    link: "https://media.dsinternational.com/instruction/Consew/241-1K.pdf",
  },
  {
    name: "CONSEW 693/694/695 Series Instruction Manual",
    brand: "Consew",
    link: "https://media.dsinternational.com/instruction/Consew/695EX.pdf",
  },
  {
    name: "CONSEW 697CVF Instruction Manual",
    brand: "Consew",
    link: "https://media.dsinternational.com/instruction/Consew/697CVF.pdf",
  },
  {
    name: "CONSEW Model 733R-5 & 733R-6 Instruction Manual & Parts Lists",
    brand: "Consew",
    link: "https://media.dsinternational.com/instruction/Consew/733R-5%20733R-6.pdf",
  },
  {
    name: "CONSEW C10NS/C20NS Instruction Manual",
    brand: "Consew",
    link: "https://media.dsinternational.com/instruction/Consew/C20NS.pdf",
  },
  {
    name: "CONSEW CM793/CM794/CM795 Instruction Manual & Parts Lists",
    brand: "Consew",
    link: "https://media.dsinternational.com/instruction/Consew/CM793.pdf",
  },
  {
    name: "CONSEW CN-7A Instruction Manual",
    brand: "Consew",
    link: "https://media.dsinternational.com/instruction/Consew/CN-7A.pdf",
  },
  {
    name: "CONSEW CSM1001 Servo Motor Instruction Manual",
    brand: "Consew",
    link: "https://media.dsinternational.com/instruction/Consew/CSM1001.pdf",
  },

    {
    name: "AC 172N-1790",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/ac172n1790.pdf",
  },
  {
    name: "Airdog Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/Airdog%20Brochure.pdf",
  },
  {
    name: "AMS-224EN Series Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/Ams224enseries%20Manual.pdf",
  },
  {
    name: "AP-876 Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/Ap-876%20Manual.pdf",
  },
  {
    name: "DDL-8700 Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/Ddl-8700%20Manual.pdf",
  },
  {
    name: "DDL 9000C Series Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/Ddl9000cseries%20Manual.pdf",
  },
  {
    name: "DLN-9010A Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/Dln-9010a%20Manual.pdf",
  },
  {
    name: "HZL-350Z Series Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/HZL-350z%20Series%20Manual.pdf",
  },
  {
    name: "HZL-70HW Instruction Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/HZL-70HW%20Instruction%20Manual.pdf",
  },
  {
    name: "HZL-80HP Instructions Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/HZL-80HP%20Instructions%20Manual.pdf",
  },
  {
    name: "HZL-F Instruction Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/HZL-F%20Instruction%20Manual.pdf",
  },
  {
    name: "HZL-F Series Parts List",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/HZL-F%20Series%20Parts%20List%20%28%29.pdf",
  },
  {
    name: "HZL-G Instruction Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/HZL-G%20Instruction%20Manual.pdf",
  },
  {
    name: "HZL-G Service Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/HZL-G%20Service%20Manual.pdf",
  },
  {
    name: "HZL-HT710 Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/HZL-Ht710%20Manual.pdf",
  },
  {
    name: "HZL-HT740 Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/HZL-Ht740%20Manual.pdf",
  },
  {
    name: "HZL-L Series Instruction Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/HZL-L%20Series%20Instruction%20Manual.pdf",
  },
  {
    name: "HZL-NX7 Adjusting The Shield",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/HZL-NX7%20Adjusting%20the%20Shield.pdf",
  },
  {
    name: "HZL-NX7 Instructions Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/HZL-NX7%20Instructions%20Manual.pdf",
  },
  {
    name: "HZL-NX7 Service Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/HZL-NX7%20Service%20Manual.pdf",
  },
  {
    name: "HZL-F Servicemanual(english)",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/Hzlf%20Servicemanual%28english%29.pdf",
  },
  {
    name: "J-350QVP Service And Parts Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/J-350QVP%20Service%20and%20Parts%20Manual.pdf",
  },
  {
    name: "Juki DX Instructional Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/JUKI%20DX%20Instructional%20Manual.pdf",
  },
  {
    name: "Juki DX Service",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/JUKI%20DX%20Service.pdf",
  },
  {
    name: "Juki Presser Foot Guide",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/JUKI%20Presser%20Foot%20Guide.pdf",
  },
  {
    name: "Juki AE10 Bobbin Thread Remaining Amount Detect Device",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/JukiAE10BobbinThreadRemainingAmountDetectDev.pdf",
  },
  {
    name: "Juki AK-138 Autolifter",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/JukiAK138Autolifter.pdf",
  },
  {
    name: "LH-3568A-7 LH-3568A Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/Lh-3568a-7%20Lh-3568a%20Manual.pdf",
  },
  {
    name: "LK-1903BN Series Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/Lk1903bnseries%20Manual.pdf",
  },
  {
    name: "MB-1370 Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/Mb1370%20Manual.pdf",
  },
  {
    name: "MCS-1500 Instructions Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/MCS-1500%20Instructions%20Manual.pdf",
  },
  {
    name: "MCS-1500 Service Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/MCS-1500%20Service%20Manual.pdf",
  },
  {
    name: "MCS-1600 Instructions Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/MCS-1600%20Instructions%20Manual.pdf",
  },
  {
    name: "MH-380 382 Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/Mh-380%20382%20Manual.pdf",
  },
  {
    name: "MO-1000 Instruction Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/MO-1000%20Instruction%20Manual.pdf",
  },
  {
    name: "MO-104 Instruction Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/MO-104%20Instruction%20Manual.pdf",
  },
  {
    name: "MO-114d Instruction Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/MO-114D%20Instruction%20Manual.pdf",
  },
  {
    name: "MO-2800",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/MO-2800%203k.pdf",
  },
  {
    name: "MO-2800 EN",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/MO-2800%20EN.pdf",
  },
  {
    name: "MO-623 Instruction Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/MO-623-Instruction-Manual.pdf",
  },
  {
    name: "MO-623 Service Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/MO-623-Service-Manual.pdf",
  },
  {
    name: "MO-644 Instructions Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/MO-644%20Instructions%20Manual.pdf",
  },
  {
    name: "MO-644 Instructions Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/MO-644-Instructions-Manual.pdf",
  },
  {
    name: "MO-654 & 654DE Instruction Manual HQ",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/MO-654%20%26%20654de%20Instruction%20Manual%20Hq.pdf",
  },
  {
    name: "MO-654 & 654de Instruction Manual HQ",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/MO-654-654DE-Instruction-Manual-HQ.pdf",
  },
  {
    name: "MO-654 & 654de Service Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/MO-654-654DE-Service-Manual.pdf",
  },
  {
    name: "MO-655 Instruction Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/MO-655-Instruction-Manual.pdf",
  },
  {
    name: "MO-655 Quick Reference",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/MO-655-Quick-Reference.pdf",
  },
  {
    name: "MO-655 Service Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/MO-655-Service-Manual.pdf",
  },
  {
    name: "MO-700 Service Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/MO-700%20Service%20Manual.pdf",
  },
  {
    name: "MO-735 Instruction Manual (esfi 29)",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/MO-735%20Instruction%20Manual%28ESFI%29.pdf",
  },
  {
    name: "MO-735 Instruction Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/MO-735%20Instruction%20Manual.pdf",
  },
  {
    name: "MO-735 Threading Chart",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/MO-735%20Threading%20Chart.pdf",
  },
  {
    name: "MO-80CB Instructions Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/MO-80CB-Instructions-Manual.pdf",
  },
  {
    name: "MO-80CB Service Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/MO-80CB-Service-Manual.pdf",
  },
  {
    name: "MO-2800 Instructions Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/MO2800%20Instructions%20Manual.pdf",
  },
  {
    name: "MO-6700D Series Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/Mo6700dseries%20Manual.pdf",
  },
  {
    name: "MO-6800S Series Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/Mo6800sseries%20Manual.pdf",
  },
  {
    name: "MO-6900G Series",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/MO6900GSeries.pdf",
  },
  {
    name: "MO-6900J Series Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/Mo6900jseries%20Manual.pdf",
  },
  {
    name: "MOL-254 Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/Mol-254%20Manual.pdf",
  },
  {
    name: "MP-200N Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/Mp-200n%20Manual.pdf",
  },
  {
    name: "Service Manual MO1000",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/Service%20manual%20MO1000.pdf",
  },
  {
    name: "TL Bobbin Tension Check",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/TL%20Bobbin%20Tension%20Check.pdf",
  },
  {
    name: "TL Pretension",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/TL%20PreTension.pdf",
  },
  {
    name: "TL-15 Instructions Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/TL-15-Instructions-Manual.pdf",
  },
  {
    name: "Tl-2010Q Instruction Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/Tl-2010q%20Instructionmanual.PDF",
  },
  {
    name: "Tl-2010Q & 2000QI Service Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/Tl-2010q-2000qi%20Servicemanual.pdf",
  },
  {
    name: "Tl-2200 QVP-S Service And Parts Manual",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/TL-2200QVP-S%20Service%20and%20Parts%20Manual.pdf",
  },
  {
    name: "TSC441 & TSN421",
    brand: "Juki",
    link: "https://media.dsinternational.com/instruction/Juki/TSC441TSN421.pdf",
  },
  {
    name: "MITSUBISHI PLKJ-CU-20 Technical Manual",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/instruction/Mitsubishi/Control%20Unit%20Manual%20PLK-J-CU-20.pdf",
  },
  {
    name: "MITSUBISHI PLK-J-CU-20S Technical Manual",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/instruction/Mitsubishi/Control%20Unit%20Manual%20PLK-J-CU-20S.pdf",
  },
  {
    name: "MITSUBISHI LS2-1180 Technical Manual",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/instruction/Mitsubishi/LS2-1180-1280-INSTRUCTION-MANUAL.pdf",
  },
  {
    name: "MITSUBISHI LS2-2210 INSTRUCTION MANUAL",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/instruction/Mitsubishi/LS2-2210-PARTS-BOOK.pdf",
  },
  {
    name: "MITSUBISHI LT2-2230 Instruction Manual",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/instruction/Mitsubishi/LT2-2230-INSTRUCTION-MANUAL.pdf",
  },
  {
    name: "MITSUBISHI LT2-2250 INSTRUCTION MANUAL",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/instruction/Mitsubishi/LT2-2250-INSTRUCTION-MANUAL.pdf",
  },
  {
    name: "MITSUBISHI LU2-4410/4430 Instruction Manual",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/instruction/Mitsubishi/LU2-4410-4430-INSTRUCTION-MANUAL.pdf",
  },
  {
    name: "MITSUBISHI LU2-4710/LU-4730 INSTRUCTION MANUAL",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/instruction/Mitsubishi/LU2-4710-4730-INSTRUCTION-MANUAL.pdf",
  },
  {
    name: "MITSUBISHI LY2-3750 INSTRUCTION MANUAL",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/instruction/Mitsubishi/LY2-3750-INSTRUCTION-MANUAL.pdf",
  },
  {
    name: "MITSUBISHI LS2-1180-1280 INSTRUCTION MANUAL",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/instruction/Mitsubishi/Mitsubishi_Industrial_Sewing_Equipment_Trimmer_Machine_Instruction_Manuals_LS2-1180-1280%20.pdf",
  },
  {
    name: "MITSUBISHI LS2-2210 Technical Manual",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/instruction/Mitsubishi/Mitsubishi_Industrial_Sewing_Equipment_Trimmer_Machine_Instruction_Manuals_LS2-2210%20.pdf",
  },
  {
    name: "MITSUBISHI LT2-2230 Technical Manual",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/instruction/Mitsubishi/Mitsubishi_Industrial_Sewing_Equipment_Trimmer_Machine_Instruction_Manuals_LT2-2230%20.pdf",
  },
  {
    name: "MITSUBISHI LU2-4410/LU2-4430 INSTRUCTION MANUAL",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/instruction/Mitsubishi/Mitsubishi_Industrial_Sewing_Equipment_Trimmer_Machine_Instruction_Manuals_LU2-4410-4430%20.pdf",
  },
  {
    name: "MITSUBISHI PLK-J10050R3 PLK-J12060R3 Technical Manual",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/instruction/Mitsubishi/PLK-J10050R-10050R3%20Mechanical%20Adjustments.PDF",
  },
  {
    name: "MITSUBISHI PLK-J2516R-YU Technical Manual",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/instruction/Mitsubishi/PLK-J2516RYU%20Mechanical%20Adjustments%20P01.pdf",
  },
  {
    name: "MITSUBISHI PLK-J2516-YU Technical Manual",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/instruction/Mitsubishi/PLK-J2516YU%20Mechanical%20Adjustments%20P01.pdf",
  },
  {
    name: "MITSUBISHI PLK-J4040 Technical Manual",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/instruction/Mitsubishi/PLK-J4040%20Mechanical%20Adjustments%20P01.pdf",
  },
  {
    name: "MITSUBISHI PLK-J4040R Technical Manual",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/instruction/Mitsubishi/PLK-J4040R%20Mechanical%20Adjustments%20P01.pdf",
  },
  {
    name: "MITSUBISHI PLK-J4040RH Technical Manual",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/instruction/Mitsubishi/PLK-J4040RH%20Mechanical%20Adjustments%20P01.pdf",
  },
  {
    name: "MITSUBISHI PLK-J6040 Technical Manual",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/instruction/Mitsubishi/PLK-J6040%20Mechanical%20Adjustments%20P02.pdf",
  },
  {
    name: "MITSUBISHI PLK-J6040R Technical Manual",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/instruction/Mitsubishi/PLK-J6040R%20Mechanical%20Adjustments.pdf",
  },
  {
    name: "MITSUBISHI PLK-J-PAL Technical Manual",
    brand: "Mitsubishi",
    link: "https://media.dsinternational.com/instruction/Mitsubishi/Touch%20Screen%20Manual%20PLK-J-PAL.pdf",
  },
];
const referenceData = [
  {
    name: "Golden Eagle Product Catalog 2019",
    brand: "Golden Eagle",
    link: "https://media.dsinternational.com/reference/Golden%20Eagle/GE2019.pdf",
  },
  {
    name: "Groz-Beckert Cloth Points",
    brand: "Groz",
    link: "https://media.dsinternational.com/reference/Groz/GBClothPoints.pdf",
  },
  {
    name: "Groz-Beckert Leather Processing Point Styles",
    brand: "Groz",
    link: "https://media.dsinternational.com/reference/Groz/GBLeatherProcPointStyles.pdf",
  },
  {
    name: "Groz-Beckert Loop Control",
    brand: "Groz",
    link: "https://media.dsinternational.com/reference/Groz/GBLoopControl.pdf",
  },
  {
    name: "Groz-Beckert Mobil Tech",
    brand: "Groz",
    link: "https://media.dsinternational.com/reference/Groz/GBMobilTech.pdf",
  },
  {
    name: "Groz-Beckert Needle Size Comparison",
    brand: "Groz",
    link: "https://media.dsinternational.com/reference/Groz/GBNeedleComp2.pdf",
  },
  {
    name: "Groz-Beckert Processing of Leather",
    brand: "Groz",
    link: "https://media.dsinternational.com/reference/Groz/GBProcLeather.pdf",
  },
  {
    name: "KANSAI SPECIAL Optional Needle Plates for KANSAI Cover-Stitch Models",
    brand: "Kansai",
    link: "https://media.dsinternational.com/reference/Kansai/KansaiCovStitchOptNdlplt.pdf",
  },
  {
    name: "KANSAI SPECIAL Gauge Adjustment Table 2016",
    brand: "Kansai",
    link: "https://media.dsinternational.com/reference/Kansai/KansaiGaugeAdjustTbl2016.pdf",
  },
  {
    name: "KANSAI SPECIAL Needle Recommendations Table By Machine 2017",
    brand: "Kansai",
    link: "https://media.dsinternational.com/reference/Kansai/KansaiNeedleRec2017.pdf",
  },
  {
    name: "KANSAI SPECIAL How to Exchange the Puller 2017",
    brand: "Kansai",
    link: "https://media.dsinternational.com/reference/Kansai/KansaiPullerExch2017.pdf",
  },
  {
    name: "Hirose to Koban Cross Reference",
    brand: "Koban",
    link: "https://media.dsinternational.com/reference/Koban/hirose2koban.pdf",
  },
  {
    name: "Koban Catalog",
    brand: "Koban",
    link: "https://media.dsinternational.com/reference/Koban/koban.pdf",
  },
  {
    name: "SCHMETZ Special Geometry Needles",
    brand: "Schmetz",
    link: "https://media.dsinternational.com/reference/Schmetz/SchmetsSpecGeometry.pdf",
  },
  {
    name: "SCHMETZ Cutting Points for Stitching Leather and Other Materials",
    brand: "Schmetz",
    link: "https://media.dsinternational.com/reference/Schmetz/SchmetzCuttingPoints.pdf",
  },
  {
    name: "SCHMETZ Round Point Needles for Stitching Textiles",
    brand: "Schmetz",
    link: "https://media.dsinternational.com/reference/Schmetz/SchmetzRoundPoints.pdf",
  },
  {
    name: "SCHMETZ Needles With Special Coating",
    brand: "Schmetz",
    link: "https://media.dsinternational.com/reference/Schmetz/SpecialNeedleCoating.pdf",
  },
];

const fullCatalogData = [
  {
    name: "Crescent Hand Tools - Complete Catalog",
    brand: "Crescent",
    link: "https://media.dsinternational.com/full-catalogs/Crescent/crecent-hand-tools-full-catalog.pdf",
  },
  {
    name: "Crescent - Adjustable Wrench Catalog",
    brand: "Crescent",
    link: "https://media.dsinternational.com/full-catalogs/Crescent/crescent-adjustable-tools.pdf",
  },
  {
    name: "Golden Eagle Complete Catalog (2019)",
    brand: "Golden Eagle",
    link: "https://media.dsinternational.com/full-catalogs/GoldenEagle/golden-eagle-full-catalog.pdf",
  },
    {
    name: "Airdog Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/Airdog%20Brochure.pdf",
  },
  {
    name: "Eb1 Catalogue Noout English Brochure Low",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/Eb1%20Catalogue%20Noout%20English%20Brochure%20Low.pdf",
  },
  {
    name: "Eb1 Catalogue Noout English Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/Eb1%20Catalogue%20Noout%20English%20Brochure.pdf",
  },
  {
    name: "HZL-12SZ Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/HZL-12SZ%20Brochure.pdf",
  },
  {
    name: "HZL-27z Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/HZL-27Z%20Brochure.pdf",
  },
  {
    name: "HZL-350z Series Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/HZL-350Z%20Series%20Brochure.pdf",
  },
  {
    name: "HZL-353ZR-C Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/HZL-353ZR-C%20Brochure.pdf",
  },
  {
    name: "HZL-355ZW-A Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/HZL-355ZW-A%20Brochure.pdf",
  },
  {
    name: "HZL-35Z Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/HZL-35Z%20Brochure.pdf",
  },
  {
    name: "HZL-70HW-A Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/HZL-70HW-A%20Brochure.pdf",
  },
  {
    name: "HZL-80HP-A Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/HZL-80HP-A%20Brochure.pdf",
  },
  {
    name: "HZL/DX7/DX5",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/HZL-DX7-DX5.pdf",
  },
  {
    name: "HZL-E61 Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/HZL-E61%20Brochure.pdf",
  },
  {
    name: "HZL-E71 Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/HZL-E71%20Brochure.pdf",
  },
  {
    name: "HZL-E80 Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/HZL-E80%20Brochure.pdf",
  },
  {
    name: "HZL-G220,g120",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/HZL-G220%2CG120.pdf",
  },
  {
    name: "HZL-K65 Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/HZL-K65%20Brochure.pdf",
  },
  {
    name: "HZL-K85 Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/HZL-K85%20Brochure.pdf",
  },
  {
    name: "HZL-LB5020 Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/HZL-LB5020%20Brochure.pdf",
  },
  {
    name: "HZL-LB5100 Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/HZL-LB5100%20Brochure.pdf",
  },
  {
    name: "HZL-25Z Catalog",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/Hzl25z%20Catalog.pdf",
  },
  {
    name: "Juki Accesories Brochure 2023 Web Quality",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/Juki%20Accesories%20Brochure%202023%20Web%20Quality.pdf",
  },
  {
    name: "Juki Accesories Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/JUKI%20Accesories%20Brochure.pdf",
  },
  {
    name: "Juki Business Plus Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/JUKI%20Business%20Plus%20Brochure.pdf",
  },
  {
    name: "Juki F-Series Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/JUKI%20F-Series%20Brochure.pdf",
  },
  {
    name: "Juki HZL-29Z Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/JUKI%20HZL-29Z%20Brochure.pdf",
  },
  {
    name: "Juki HZL-HT710 Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/JUKI%20HZL-HT710%20Brochure.pdf",
  },
  {
    name: "Juki HZL-HT740 Brochure-",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/Juki%20HZL-Ht740%20Brochure-.pdf",
  },
  {
    name: "Juki HZL-HT740 Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/JUKI%20HZL-HT740%20Brochure.pdf",
  },
  {
    name: "Juki HZL-NX7 Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/JUKI%20HZL-NX7%20Brochure.pdf",
  },
  {
    name: "Juki MO-60 & MO-700 Series Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/Juki%20MO-600-MO-700%20Series%20Brochure.pdf",
  },
  {
    name: "Juki MO-600-MO-735 Series Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/Juki%20MO-600-MO-735%20Series%20Brochure.pdf",
  },
  {
    name: "Juki Sergers Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/JUKI%20Sergers%20Brochure.pdf",
  },
  {
    name: "Juki-Accesories-Brochure-2023 Web-Quality",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/Juki-Accesories-Brochure-2023%20Web-Quality.pdf",
  },
  {
    name: "Juki MO-80CB Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/JUKI-MO-80CB-Brochure.pdf",
  },
  {
    name: "MCS-1500 Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/Mcs-1500%20Brochure.pdf",
  },
  {
    name: "MCS-1600 High Quality Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/Mcs-1600%20High%20Quality%20Brochure.pdf",
  },
  {
    name: "MCS-1600 Web Quality",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/Mcs-1600%20Web%20Quality.pdf",
  },
  {
    name: "MO-1000 Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/MO-1000%20Brochure.pdf",
  },
  {
    name: "MO-114D 104d Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/MO-114d%20104d%20Brochure.pdf",
  },
  {
    name: "MO-700 Series Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/MO-700%20Series%20Brochure.pdf",
  },
  {
    name: "MO-2800 High Res",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/Mo2800%20High%20Res.pdf",
  },
  {
    name: "MO-2800 USA Catalog S",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/Mo2800%20USA%20Catalog%20S.pdf",
  },
  {
    name: "MO-600 Comparison Sheet",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/MO600%20Comparison%20Sheet.pdf",
  },
  {
    name: "MO-623 & 644d Catalog",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/Mo623%20644d%20Catalog.pdf",
  },
  {
    name: "MO-654DE 655 Catalog",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/Mo654de%20655%20Catalog.pdf",
  },
  {
    name: "Richtech Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/Richtech%20Brochure.pdf",
  },
  {
    name: "TL-15 Catalog Web Quality",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/Tl-15-Catalog%20Web%20Quality.pdf",
  },
  {
    name: "Tl-2000QI Onlinecatalog",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/Tl-2000qi%20Onlinecatalog.pdf",
  },
  {
    name: "TL-2010Q Brochure",
    brand: "Juki",
    link: "https://media.dsinternational.com/full-catalogs/Juki/TL2010Q-Brochure.pdf",
  },
];

var myJSON;
var tableType = "";
if (document.body.contains(document.getElementById("partsTable"))) {
  tableType = "partsTable";
  myJSON = partsData;
} else if (document.body.contains(document.getElementById("manualsTable"))) {
  tableType = "manualsTable";
  myJSON = manualsData;
} else if (document.body.contains(document.getElementById("referenceTable"))) {
  tableType = "referenceTable";
  myJSON = referenceData;
} else if (document.body.contains(document.getElementById("fullCatalogTable"))) {
  tableType = "fullCatalogTable";
  myJSON = fullCatalogData;
}

const tableBody = document.querySelector("#" + tableType + " tbody");
myJSON.forEach((doc) => {
  const row = document.createElement("tr");
  const nameCell = document.createElement("td");
  nameCell.textContent = doc.name;
  row.appendChild(nameCell);

  const brandCell = document.createElement("td");
  brandCell.textContent = doc.brand;
  row.appendChild(brandCell);

  const linkCell = document.createElement("td");
  //linkCell.textContent = doc.link;
  var link = document.createElement("a");
  link.setAttribute("href", doc.link);
  link.setAttribute("target", "_blank");
  var newimg = document.createElement("img");
  newimg.src =
    "https://cdn.shopify.com/s/files/1/0635/1873/6546/files/download-icon-download_file_files_pdf_icon-1320184619509952330_64.png?v=1712597948";
  newimg.alt = "imageMissing";
  newimg.width = "48";
  newimg.height = "48";
  newimg.border = "0";
  link.appendChild(newimg);
  linkCell.appendChild(link);
  row.appendChild(linkCell);

  tableBody.appendChild(row);
});

function FilterFunction() {
  var input, filter, table, tr, td, i, txtValue;
  input = document.getElementById("searchBox");
  filter = input.value.toUpperCase();
  table = document.getElementById(tableType);
  tr = table.getElementsByTagName("tr");
  for (i = 0; i < tr.length; i++) {
    td = tr[i].getElementsByTagName("td")[0];
    if (td) {
      txtValue = td.textContent || td.innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        tr[i].style.display = "";
      } else {
        tr[i].style.display = "none";
      }
    }
  }
}
/*
//new code 
const getCellValue = (tr, idx) => {
  const cell = tr.children[idx];
  return cell.innerText || cell.textContent;
};

const comparer = (idx, asc) => (a, b) => {
  const v1 = getCellValue(a, idx).replace(/[^0-9.]/g, ""); // Remove non-numeric characters
  const v2 = getCellValue(b, idx).replace(/[^0-9.]/g, ""); // Remove non-numeric characters

  if (v1 !== "" && v2 !== "" && !isNaN(v1) && !isNaN(v2)) {
    return (v1 - v2) * (asc ? 1 : -1); // Numeric comparison
  } else {
    return (getCellValue(a, idx).localeCompare(getCellValue(b, idx))) * (asc ? 1 : -1); // String comparison
  }
};

document.querySelectorAll("th").forEach((th) => {
  let asc = true; // Track sort order for this column

  th.addEventListener("click", () => {
    const table = th.closest("table");
    if (!table) return; // Ensure the table exists

    const tbody = table.querySelector("tbody");
    if (!tbody) return; // Ensure the tbody exists

    Array.from(tbody.querySelectorAll("tr"))
      .sort(comparer(Array.from(th.parentNode.children).indexOf(th), asc))
      .forEach((tr) => tbody.appendChild(tr));

    asc = !asc; // Toggle sort order
  });
});
*/

const getCellValue = (tr, idx) =>
  tr.children[idx].innerText || tr.children[idx].textContent;

const comparer = (idx, asc) => (a, b) =>
  ((v1, v2) =>
    v1 !== "" && v2 !== "" && !isNaN(v1) && !isNaN(v2)
      ? v1 - v2
      : v1.toString().localeCompare(v2))(
    getCellValue(asc ? a : b, idx),
    getCellValue(asc ? b : a, idx)
  );

document.querySelectorAll("th").forEach((th) =>
  th.addEventListener("click", () => {
    const table = th.closest("table");
    const tbody = table.querySelector("tbody");
    Array.from(tbody.querySelectorAll("tr"))
      .sort(
        comparer(
          Array.from(th.parentNode.children).indexOf(th),
          (this.asc = !this.asc)
        )
      )
      .forEach((tr) => tbody.appendChild(tr));
  })
);
